<script setup lang="ts">
import { computed, useId } from "vue";

const props = defineProps({
  label: { type: String, required: true },
  id: { type: String, default: undefined },
  required: { type: Boolean, default: false },
  labelPlacement: {
    type: String as () => "top" | "left" | "right" | "bottom",
    default: "top",
  },
});

const fieldId = props.id ?? useId();

const placementClass = computed(
  () => `form-field-placement-${props.labelPlacement}`
);
</script>

<template>
  <div class="form-field-container" :class="placementClass">
    <div
      class="form-field-label-row"
      :class="{ 'form-field-label-row-with-action': $slots['label-action'] }"
    >
      <label :for="fieldId" class="form-field-label">
        {{ label }}
        <span v-if="required" class="ml-0.75 text-[#c0392b]" aria-hidden="true"
          >*</span
        >
        <input
          :id="fieldId"
          class="sr-only"
          readonly
          tabindex="-1"
          type="text"
        />
      </label>
      <slot name="label-action" />
    </div>
    <slot />
  </div>
</template>

<style scoped>
.form-field-label-row {
  display: contents;
}

.form-field-label-row-with-action {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}
</style>
